var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container",class:{
    desktop: _vm.isDesktop,
    'is-ios': _vm.isIOS,
    'booking-flow': _vm.isBookingFlow,
  }},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }